<template>
  <!-- Some sozinho quando cabe tudo numa pagina: secao curta nao ganha controle
       que nao faz nada. -->
  <div
    v-if="totalPaginas > 1"
    class="d-flex align-center pa-1"
    style="gap: 6px; background: #fff; border: 1px solid #1976d2; border-radius: 22px; box-shadow: 0 1px 4px rgba(25,118,210,0.25)"
  >
    <span
      class="caption font-weight-medium primary--text text-uppercase pl-2"
      style="letter-spacing: 0.06em; font-size: 10px"
    >{{ rotulo }}</span>

    <v-btn
      small
      color="primary"
      depressed
      :disabled="pagina <= 1"
      class="px-0"
      style="min-width: 32px"
      @click="$emit('mudar', -1)"
    >
      <v-icon small>mdi-chevron-left</v-icon>
    </v-btn>

    <span
      class="body-2 font-weight-bold primary--text"
      style="min-width: 54px; text-align: center; letter-spacing: 0.5px"
    >{{ pagina }} / {{ totalPaginas }}</span>

    <v-btn
      small
      color="primary"
      depressed
      :disabled="pagina >= totalPaginas"
      class="px-0"
      style="min-width: 32px"
      @click="$emit('mudar', 1)"
    >
      <v-icon small>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
/**
 * Controle de paginacao das secoes de um card de meta (participantes, modelos,
 * metas do participante).
 *
 * Extraido de ListaCardMetas quando a terceira secao precisou paginar: o markup
 * ja estava duplicado uma vez, e triplicar deixaria tres copias para manter em
 * sincronia. So apresentacao — a pagina atual e o fatiamento ficam com quem usa.
 */
export default {
  name: "PaginadorSecao",

  props: {
    pagina: { type: Number, required: true },
    totalPaginas: { type: Number, required: true },
    rotulo: { type: String, required: true }
  }
};
</script>
